export default "__VITE_ASSET__Cdzjp$0y__"